<template>
	<slot />
</template>

<script setup lang="ts">
import type { ImagePriority } from "~/layers/base/utils/imagePriority";

/**
 * Renderless: tells the bloks in its slot whether they are first-screen
 * content, so only the top of a page (and its nested images) preloads.
 * Adds no element, so it does not disturb the parent's grid or flex layout.
 */
interface Props {
	priority: boolean | ImagePriority;
}
const { priority } = defineProps<Props>();

provideBlokPriority(() => priority);
</script>
